import { useLanguage } from "@/contexts/LanguageContext";

export function SelfCarCheckFAB({ onClick }: { onClick: () => void }) {
  const { language } = useLanguage();
  const isTh = language === "th";

  return (
    <button
      onClick={onClick}
      aria-label={isTh ? "ตรวจสุขภาพรถ" : "Self car health check"}
      className="fixed right-6 z-50 group flex items-center justify-center gap-1.5 w-[136px] h-10 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 active:scale-95 border border-white/20"
      style={{
        background: "linear-gradient(135deg, #020617 0%, #172554 25%, #1e3a8a 50%, #172554 75%, #020617 100%)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.25), inset 0 -1px 0 rgba(0,0,0,0.2)",
        bottom: "calc(3.75rem + env(safe-area-inset-bottom, 0px))",
      }}
    >
      <span className="absolute -top-1.5 right-2 text-[13px] font-bold tracking-wide text-white/90">
        Free
      </span>
      <span className="text-sm font-bold text-white tracking-wide drop-shadow-sm">
        {isTh ? "ตรวจสุขภาพรถ" : "Car Check"}
      </span>
      <div
        className="absolute inset-0 rounded-full bg-gradient-to-r from-white/0 via-white/30 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
        style={{ backgroundSize: "200% 100%", animation: "shimmer 2s infinite" }}
      />
    </button>
  );
}
